/**
 * Resolve a required immutable asset deployment version.
 *
 * Legacy root-relative public asset URLs are intentionally unsupported.
 *
 * @param {string | null | undefined} rawValue
 * @param {string} envName
 * @returns {string}
 */
function resolveStaticAssetDeploymentVersion(rawValue, envName) {
  const value = typeof rawValue === 'string' ? rawValue.trim() : '';
  if (value.length > 0) {
    return value;
  }

  throw new Error(
    `${envName} must be set for immutable public assets. Legacy unversioned asset URLs are not supported.`
  );
}

function resolveBuildTimeStaticAssetDeploymentVersion() {
  return resolveStaticAssetDeploymentVersion(process.env.DEPLOYMENT_VERSION, 'DEPLOYMENT_VERSION');
}

function resolveRuntimeStaticAssetDeploymentVersion() {
  return resolveStaticAssetDeploymentVersion(
    process.env.PUBLIC_ASSET_DEPLOYMENT_VERSION,
    'PUBLIC_ASSET_DEPLOYMENT_VERSION'
  );
}

module.exports = {
  resolveStaticAssetDeploymentVersion,
  resolveBuildTimeStaticAssetDeploymentVersion,
  resolveRuntimeStaticAssetDeploymentVersion,
};
